import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { showMessage } from 'src/shared/AppUtils';
import styled from 'styled-components';
import DataTable from 'src/shared/components/DataTable';
import { getRecordContentApi, reserveBookApi } from './ApiService';

const Wrapper = styled.div``;

const LinkButton = styled(Button)`
  :hover {
    span {
      color: #40a9ff;
    }
  }
`;

function DocStore({ id }) {
  const [docList, setDocList] = useState([]);
  const [isReserving, setIsReserving] = useState(false);

  const getConent = () => {
    const params = { id, type: 'inv' };
    getRecordContentApi(params).then((data) => setDocList(data));
  };

  const reserveBook = (inventoryId) => {
    setIsReserving(true);
    reserveBookApi(id, inventoryId)
      .then(({ data: { Success, Message } }) => {
        if (Success) {
          showMessage(
            'Thông báo',
            `Đặt chỗ tài liệu thành công. Hạn chót đến nhận sách là ${Message}.`
          );
          return;
        }
        showMessage(
          'Thông báo',
          Message === 'NOT_LOGIN' ? 'Chưa đăng nhập, đặt chỗ thất bại' : Message
        );
      })
      .finally(() => {
        setIsReserving(false);
      });
  };

  const columns = [
    {
      title: 'Tên Kho',
      dataIndex: 'InventoryName',
      key: 'InventoryName',
    },
    {
      title: 'Số bản',
      dataIndex: 'AvailableCopies',
      key: 'AvailableCopies',
      render: (AvailableCopies, { NumberOfCopies }) =>
        `${AvailableCopies}/${NumberOfCopies}`,
    },
    {
      title: 'Tương tác',
      dataIndex: 'react',
      key: 'React',
      render: (_, record) => (
        <LinkButton
          loading={isReserving}
          type="link"
          onClick={() => reserveBook(record.InventoryID)}
        >
          Đặt chỗ
        </LinkButton>
      ),
    },
  ];

  useEffect(() => {
    getConent();
  }, []);

  return (
    <Wrapper>
      <DataTable dataSource={docList} columns={columns} />
    </Wrapper>
  );
}

export default DocStore;
